import { UPDATE_INSTITUTION_AFFILIATION_SUMMARY } from 'stores/redux/actions/types';

import hOReducer from '../common/reducer';

const reducer = hOReducer(UPDATE_INSTITUTION_AFFILIATION_SUMMARY, {});
export default reducer;
